import { createContext, Dispatch } from 'react';
import { ActionTypes, SettingsState } from './types';
import { PwaPromptTools } from './hooks/useInstallPwaPrompt';
import { LiveChatTools } from 'src/modules/livechat/useLiveChat';

export type SettingsContextType = SettingsState & {
  setSettings: Dispatch<ActionTypes>;
  pwa: PwaPromptTools;
  chat: LiveChatTools;
};

/** Контекст для хранения различных переменных, ради которых не хочется создавать
 * индивидуальный контекст
 */
export const SettingsContext = createContext<SettingsContextType>({} as SettingsContextType);
